import { TOOLS } from "../data/content";

function Chip({ tool, index }) {
  return (
    <span
      className="flex shrink-0 items-center gap-3 rounded-full border border-black/10 bg-white pl-3 pr-6 py-2.5 transition-transform duration-300 hover:-translate-y-0.5"
      data-testid={`tool-${index}`}
    >
      <img
        src={tool.logo}
        alt={`${tool.name} logo`}
        loading="lazy"
        className="h-8 w-8 md:h-9 md:w-9 object-contain shrink-0"
      />
      <span className="font-display text-lg md:text-xl tracking-tight text-[#0a0a0a] whitespace-nowrap">{tool.name}</span>
    </span>
  );
}

function Strip() {
  return (
    <div className="flex shrink-0 items-center gap-4 md:gap-6 pr-4 md:pr-6">
      {TOOLS.map((t, i) => (
        <Chip key={t.name + i} tool={t} index={i} />
      ))}
    </div>
  );
}

export default function ToolsMarquee() {
  return (
    <div className="w-full overflow-hidden py-2 select-none" data-testid="tools-marquee">
      <div className="marquee-track-reverse">
        <Strip />
        <Strip />
      </div>
    </div>
  );
}
